import { render, staticRenderFns } from "./classifiersCreateForm.vue?vue&type=template&id=67c2c1e4&scoped=true"
import script from "./classifiersCreateForm.vue?vue&type=script&lang=js"
export * from "./classifiersCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c2c1e4",
  null
  
)

export default component.exports